export const getLanguageFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const urlLanguage = urlParams.get("language");

  return urlLanguage;
};
